"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDateList = void 0;
exports.validateAndCreateConfig = validateAndCreateConfig;
exports.validateAndCreateRelativeConfig = validateAndCreateRelativeConfig;
const luxon_1 = require("luxon");
const common_1 = require("@finley-technologies/common");
const offset_1 = require("../utils/offset");
const range_1 = require("../utils/range");
const getPeriodEdgeDateOperator = (type, period) => {
    switch (type) {
        case 'startOf':
            return (dateTime) => dateTime.startOf(period);
        case 'endOf':
            return (dateTime) => dateTime.endOf(period);
        default:
            return (0, common_1.finleyAssertUnreachable)(type);
    }
};
const createDateList = (recurringDateConfig) => {
    (0, common_1.finleyAssert)('type' in recurringDateConfig &&
        (recurringDateConfig.type === 'startOf' ||
            recurringDateConfig.type === 'endOf'), `Recurring date config type must be startOf or endOf, received type [${recurringDateConfig.type}]`);
    const { startDate, endDate, type, period, cadence, offset, } = recurringDateConfig;
    const startDateTime = luxon_1.DateTime.fromISO(startDate);
    const endDateTime = luxon_1.DateTime.fromISO(endDate);
    const dateList = [];
    const periodEdgeDatetime = getPeriodEdgeDateOperator(type, period)(startDateTime);
    let currentDateTime = luxon_1.DateTime.fromISO(common_1.date.datetimeToFullDateStr(periodEdgeDatetime));
    // @jendevelops TODO: add support for setting inclusive/ exclusive on start date in config
    // eslint-disable-next-line no-restricted-syntax
    while (currentDateTime <= endDateTime) {
        const periodEdgeDate = getPeriodEdgeDateOperator(type, period)(currentDateTime);
        const newDate = (0, offset_1.applyOffset)({
            offset: offset ?? { days: 0, dayUnit: 'calendarDay' },
            date: periodEdgeDate,
        });
        if ((0, range_1.isDateInRange)({
            date: newDate,
            start: startDate,
            end: endDate,
        })) {
            dateList.push(newDate);
        }
        currentDateTime = currentDateTime.plus({ [period]: cadence });
    }
    return dateList;
};
exports.createDateList = createDateList;
function validateAndCreateConfig(type, startDate, endDate, period, cadence = 0, offsetDayUnit = 'calendarDay', offsetDays = 0, offsetNonBusinessDayAdjustment) {
    if (period === 'week') {
        return {
            config: null,
            error: { frequency: 'Frequency cannot be `week`, must be recurring.' },
        };
    }
    const offset = offsetDayUnit === 'calendarDay'
        ? {
            dayUnit: offsetDayUnit,
            days: offsetDays,
            nonBusinessDayAdjustment: offsetNonBusinessDayAdjustment,
        }
        : {
            dayUnit: offsetDayUnit,
            days: offsetDays,
        };
    const startOrEndOfConfig = {
        type,
        startDate,
        endDate,
        period,
        cadence,
        offset,
    };
    return { config: startOrEndOfConfig, error: {} };
}
function validateAndCreateRelativeConfig(type, startDateFormula, endDateFormula, period, cadence = 0, offsetDayUnit = 'calendarDay', offsetDays = 0, offsetNonBusinessDayAdjustment) {
    if (period === 'week') {
        return {
            config: null,
            error: { frequency: 'Frequency cannot be `week`, must be recurring.' },
        };
    }
    const offset = offsetDayUnit === 'calendarDay'
        ? {
            dayUnit: offsetDayUnit,
            days: offsetDays,
            nonBusinessDayAdjustment: offsetNonBusinessDayAdjustment,
        }
        : {
            dayUnit: offsetDayUnit,
            days: offsetDays,
        };
    const startOrEndOfConfig = {
        type,
        period,
        cadence,
        offset,
    };
    return {
        config: {
            startDateFormula,
            endDateFormula,
            baseDateConfig: startOrEndOfConfig,
        },
        error: {},
    };
}
//# sourceMappingURL=startOrEndOfPeriod.js.map